import { render, staticRenderFns } from "./ForeclosurePdfTemplate.vue?vue&type=template&id=2c013342"
import script from "./ForeclosurePdfTemplate.vue?vue&type=script&lang=js"
export * from "./ForeclosurePdfTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports